// ABOUTME: Profile page with cyberpunk-styled user information display
// ABOUTME: Shows authenticated user details with gradient cards and neon effects
import { useEffect, useState } from "react";

// Msal imports
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";

// Sample app imports
import { Loading } from "../ui-components/Loading";
import { ErrorComponent } from "../ui-components/ErrorComponent";
import { User, Mail, Shield, Key } from "lucide-react";

const ProfileContent = () => {
    const { instance, accounts } = useMsal();
    const [profileData, setProfileData] = useState<any>(null);

    useEffect(() => {
        if (accounts[0]) {
            setProfileData(accounts[0]);
        }
    }, [accounts, instance]);

    return (
        <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
                <h1 className="text-4xl md:text-6xl font-bold mb-4 text-gradient-cyberpunk tracking-tight">
                    USER PROFILE
                </h1>
                <p className="text-blue-300 text-lg md:text-xl tracking-widest">
                    AUTHENTICATED USER INFORMATION
                </p>
            </div>

            {profileData ? (
                <div className="bg-black/70 backdrop-blur-sm p-8 rounded-lg border-2 border-blue-500 glow-blue">
                    <div className="flex items-center mb-8">
                        <div className="p-4 rounded-lg bg-gradient-to-r from-blue-500 to-purple-600 mr-4">
                            <User className="w-12 h-12 text-white" />
                        </div>
                        <div>
                            <h2 className="text-2xl font-bold text-yellow-400 font-mono">
                                {profileData.name || profileData.username}
                            </h2>
                            <p className="text-green-400 font-mono text-sm">AUTHENTICATED</p>
                        </div>
                    </div>

                    <div className="space-y-4">
                        <div className="p-4 rounded-lg bg-gray-900/50 border border-blue-500/30">
                            <div className="flex items-center mb-2">
                                <Mail className="w-5 h-5 text-blue-400 mr-2" />
                                <span className="text-green-400 font-mono text-sm">EMAIL</span>
                            </div>
                            <p className="text-blue-300 font-mono">{profileData.username}</p>
                        </div>

                        <div className="p-4 rounded-lg bg-gray-900/50 border border-blue-500/30">
                            <div className="flex items-center mb-2">
                                <Key className="w-5 h-5 text-blue-400 mr-2" />
                                <span className="text-green-400 font-mono text-sm">USER ID</span>
                            </div>
                            <p className="text-blue-300 font-mono text-xs break-all">{profileData.localAccountId}</p>
                        </div>

                        <div className="p-4 rounded-lg bg-gray-900/50 border border-blue-500/30">
                            <div className="flex items-center mb-2">
                                <Shield className="w-5 h-5 text-blue-400 mr-2" />
                                <span className="text-green-400 font-mono text-sm">TENANT ID</span>
                            </div>
                            <p className="text-blue-300 font-mono text-xs break-all">{profileData.tenantId}</p>
                        </div>

                        {profileData.idTokenClaims && (
                            <div className="p-4 rounded-lg bg-gray-900/50 border border-blue-500/30">
                                <div className="flex items-center mb-2">
                                    <Shield className="w-5 h-5 text-blue-400 mr-2" />
                                    <span className="text-green-400 font-mono text-sm">AUTHENTICATION METHOD</span>
                                </div>
                                <p className="text-blue-300 font-mono">{profileData.environment || "Entra External ID"}</p>
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <div className="bg-black/70 backdrop-blur-sm p-12 rounded-lg border-2 border-blue-500 glow-blue text-center">
                    <p className="text-blue-300 font-mono">Loading profile data...</p>
                </div>
            )}
        </div>
    );
};

export function Profile() {
    const authRequest = {
        ...loginRequest
    };

    return (
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={authRequest}
            errorComponent={ErrorComponent}
            loadingComponent={Loading}
        >
            <ProfileContent />
        </MsalAuthenticationTemplate>
    )
};